import { LocationStrategy } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'app-loyalty-enrollment-tile',
  templateUrl: './loyalty-enrollment-tile.component.html',
  styleUrls: ['./loyalty-enrollment-tile.component.scss']
})
export class LoyaltyEnrollmentTileComponent implements OnInit {
  @Input() isLoading: boolean;

  @Output() loginTrigger: EventEmitter<void> = new EventEmitter<void>();
  @Output() createAccountTrigger: EventEmitter<void> = new EventEmitter<void>();
  @Output() initTrigger: EventEmitter<void> = new EventEmitter<void>();

  public acceptTerms: UntypedFormControl;
  loyaltyEnrollmentTileDescriptionString = $localize`:@@loyalty-enrollment-tile.loyaltyEnrollmentTileDescription:With Amadeus+Me,
  you accumulate points for every booking you make. Use your points to choose gifts from the catalog.`;
  moreDetailsString = $localize`:@@loyalty-enrollment-tile.moreDetails:More details`;
  loyaltyApproveTileApproveButton = $localize`:@@loyalty-enrollment-tile.loyaltyApproveTileApproveButton:Approve`;
  loyaltyEnrollmentTileAcceptTermsOfUseString = $localize`:@@loyalty-enrollment-tile.loyaltyEnrollmentTileAcceptTermsOfUse:I agree to the `;
  termsLink: string;

  constructor(
    private readonly fb: FormBuilder,
    private readonly modalService: NgbModal,
    private readonly location: LocationStrategy
  ) {
    this.acceptTerms = this.fb.control(false, Validators.requiredTrue);
  }

  ngOnInit(): void {
    this.initTrigger.emit();
    this.termsLink = this.location.prepareExternalUrl('/content/registration-amadeus-plus-me-agreement');
  }

  handleLoginClick() {
    this.loginTrigger.emit();
  }

  handleCreateAccountClick(content) {
    if (this.acceptTerms.invalid) {
      return;
    }

    this.modalService
      .open(content, {
        centered: true,
        container: 'body',
        backdrop: 'static'
      })
      .result.then(
        () => {
          this.createAccountTrigger.emit();
        },
        () => {
          // on error/dismiss
        }
      );
  }
}
